import classNames from 'classnames';
import React, { FunctionComponent } from 'react';

interface LoaderProps {
  size?: 'sm' | 'lg';
}

const Loader: FunctionComponent<LoaderProps> = ({ size = 'sm' }) => {
  return (
    <svg
      viewBox="0 0 38 38"
      className={classNames('animate-spin stroke-current text-black-600 mr-2', {
        'h-5': size === 'sm',
        'w-5': size === 'sm',
        'h-20': size === 'lg',
        'w-20': size === 'lg',
      })}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <g transform="translate(1 1)" strokeWidth="2">
          <circle strokeOpacity=".5" cx="18" cy="18" r="18" />
          <path d="M36 18c0-9.94-8.06-18-18-18">
            <animateTransform
              attributeName="transform"
              type="rotate"
              from="0 18 18"
              to="360 18 18"
              dur="1s"
              repeatCount="indefinite"
            />
          </path>
        </g>
      </g>
    </svg>
  );
};

export default Loader;
